export default {
  title: 'Premium',
  subtitle: 'Pilotez la répartition des leads entre courtage et commissionnaire.',
  helpLabel: 'Comprendre les règles de répartition',
  help: 'Chaque verticale possède ses propres règles par distance et surface. Cliquez sur une case pour choisir la part Courtage, par paliers de 25 %. Le reste est automatiquement envoyé en Commissionnaire.',
  vertical: 'Verticale d’acquisition',
  channels: {
    seo: 'SEO',
    seoHelper: 'Organique',
    sea: 'SEA',
    seaHelper: 'Payant',
  },
  courtage: 'Courtage',
  commissionnaire: 'Commissionnaire',
  surface: 'Surface',
  save: 'Enregistrer les règles',
  saving: 'Enregistrement…',
  saved: 'Règles enregistrées',
  changed: 'Répartition modifiée · {target}',
  modal: {
    label: 'Modifier la répartition du flux',
    description: 'Choisissez la part du flux envoyée en courtage.',
    helper: 'La part restante est automatiquement envoyée en commissionnaire.',
    apply: 'Appliquer',
  },
};
